import { render, staticRenderFns } from "./arrivedGive-table.vue?vue&type=template&id=7132ee99"
import script from "./arrivedGive-table.vue?vue&type=script&lang=js"
export * from "./arrivedGive-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports